import React from "react";
import { ProgressBar, ProgressDone, ProgressBarWrapper, ProgressValue } from "./ProgressBarStyles";

export const Progress = ({ percentage, withSymbol }) => (
  <ProgressBarWrapper>
    <ProgressBar>
      <ProgressDone width={percentage} />
    </ProgressBar>
    {withSymbol && <ProgressValue>{percentage}%</ProgressValue>}
  </ProgressBarWrapper>
);
